<template>
	<div>
		<b-modal ref="modal_error"
			hide-footer
			:title="$t('Errors.error')">
			<p class="my-4">{{ $t("Errors.message_general") }}</p>
		</b-modal>

		<b-modal ref="modal_success"
			hide-footer
			@hidden="redirect"
			:title="$t('Report.modal_title')">
			<p class="my-4">{{ $t("Report.modal_message") }}</p>
		</b-modal>

		<b-modal ref="modalError"
			hide-footer
			static="true"
			lazy="true"
			:title="$t('Errors.error')">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<Navbar :name="navbarName" />
		<b-container active>
			<b-row>
				<b-col v-if="true" class="item_download">
					<a target="_blank" rel="noopener" href="./static/notices/Notice_Web.pdf" download="Notice SWM Vidéo - Web.pdf">
						<b-row>
							<img class="document" :src="'./static/images/pictos/document.svg'" width="100">
						</b-row>
						<b-row>
							<span class="document_description">Notice d'utilisation<br />Web (français)</span>
						</b-row>
					</a>
				</b-col>

				<b-col v-if="true" class="item_download">
					<a href="./static/notices/Notice_App.pdf" download="Notice HQ Vidéo - Mobile.pdf">
						<b-row>
							<img class="document" :src="'./static/images/pictos/document.svg'" width="100">
						</b-row>
						<b-row>
							<div class="document_description">Notice d'utilisation<br />Mobile (français)</div>
						</b-row>
					</a>
				</b-col>

				<b-col v-if="false" class="item_download">
					<a target="_blank" rel="noopener" href="./static/notices/NOTICE_WEB_EN.pdf" download="HQ Vidéo Instructions - Web.pdf">
						<b-row>
							<img class="document" :src="'./static/images/pictos/document.svg'" width="100">
						</b-row>
						<b-row>
							<span class="document_description">Instructions<br />Web (english)</span>
						</b-row>
					</a>
				</b-col>

				<b-col v-if="false" class="item_download">
					<a href="./static/notices/NOTICE_MOBILE_EN.pdf" download="HQ Vidéo Instructions - Mobile.pdf">
						<b-row>
							<img class="document" :src="'./static/images/pictos/document.svg'" width="100">
						</b-row>
						<b-row>
							<div class="document_description">Instructions<br />Mobile (english)</div>
						</b-row>
					</a>
				</b-col>

				<b-col v-if="false" class="item_download">
					<a href="/dist/EnjoybCapture.exe" title="">
						<b-row>
							<img class="document" :src="'./static/images/pictos/logo-eb.png'" width="100">
						</b-row>
						<b-row>
							<div class="document_description">EnjoyB Capture</div>
						</b-row>
					</a>
				</b-col>
			</b-row>
		</b-container>

		<b-form @submit="onSubmit" v-if="show" id="form_report" class="col-6">
			<h2>{{ $t("Report.problem") }}</h2>
			<b-form-group id="input-group-society" label-for="input-society"
				:label="$t('Report.society')">
				<b-form-input
					id="input-society"
					v-model="form.society"
					type="text"
					required
				></b-form-input>
			</b-form-group>

			<b-form-group id="input-group-date" label-for="input-date"
				:label="$t('Report.date')">
				<b-form-input
					id="input-date"
					v-model="form.date"
					type="date"
					required
				></b-form-input>
			</b-form-group>

			<b-form-group id="input-group-email" label-for="input-email"
				:label="$t('Report.mail')">
				<b-form-input
					id="input-email"
					v-model="form.email"
					type="email"
					required
				></b-form-input>
			</b-form-group>

			<b-form-group id="input-group-support" label-for="input-support"
				:label="$t('Report.support')">
				<b-form-select v-model="form.support_selected"
					:options="support_options"
					id="input-support"
					@change="support_change">
					<template v-slot:first>
						<option :value="null" disabled>-- {{ $t("Report.default_option") }} --</option>
					</template>
				</b-form-select>
			</b-form-group>

			<b-form-group id="input-group-model" label-for="input-model"
				:label="$t('Report.model')">
				<b-form-input
					id="input-model"
					v-model="form.model"
					type="text"
					required
				></b-form-input>
			</b-form-group>

			<b-form-group id="input-group-osversion" label-for="input-osversion"
				:label="$t('Report.osversion')">
				<b-form-input
					id="input-osversion"
					v-model="form.osversion"
					type="text"
					required
				></b-form-input>
			</b-form-group>

			<b-form-group :label="$t('Report.incident')">
				<b-form-group id="input-group-context" label-for="input-context"
					:label="$t('Report.context')">
					<b-form-select v-model="form.context_selected"
						:options="contexts[this.form.support_selected]"
						id="input-context" :disabled="isContextDisabled"
						@change="context_change">
						<template v-slot:first>
							<option :value="null" disabled>-- {{ $t("Report.default_option") }} --</option>
						</template>
					</b-form-select>
				</b-form-group>

				<b-form-group id="input-group-thematic" label-for="input-thematic"
					:label="$t('Report.thematic')">
					<b-form-select v-model="form.thematic_selected"
						:options="thematics[this.form.context_selected]"
						id="input-thematic" :disabled="isThematicDisabled"
						@change="thematic_change">
						<template v-slot:first>
							<option :value="null" disabled>-- {{ $t("Report.default_option") }} --</option>
						</template>
					</b-form-select>
				</b-form-group>

				<b-form-group id="input-group-detail" label-for="input-detail"
					:label="$t('Report.detail')">
					<b-form-select v-model="form.detail_selected"
						:options="details[this.form.thematic_selected]"
						id="input-detail" :disabled="isDetailDisabled">
						<template v-slot:first>
							<option :value="null" disabled>-- {{ $t("Report.default_option") }} --</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-form-group>

			<b-form-group id="input-group-comments" label-for="input-comments" :label="$t('Report.comments')">
				<b-form-textarea v-model="form.comments" id="input-comments"></b-form-textarea>
			</b-form-group>

			<b-button type="submit" variant="primary">{{ $t("Report.send") }}</b-button>
		</b-form>
	</div>
</template>

<script>
import Navbar from "../ui/Navbar";
import axios from "axios";
import lottie_error from "@/components/ui/lottie_error";

export default {
	name: "Dashboard",
	components: {
		Navbar,
		lottie_error,
	},
	data() {
		return {
			disabled: false,

			form: {
				society: "",
				date: new Date().toISOString().split("T")[0],
				email: "",
				support_selected: null,
				model: "",
				osversion: "",
				context_selected: null,
				thematic_selected: null,
				detail_selected: null,
				comments: "",
			},

			hasLibrary: process.env.VUE_APP_HAS_VIDEO_LIBRARY,
			projects: [],
			show: false,
			videoUrl: "",
			text_error: "",
		};
	},
	computed: {
		isContextDisabled() {
			return this.form.support_selected == null; // this.form.support_selected == null
		},
		isThematicDisabled() {
			return this.form.context_selected == null; // this.form.support_selected == null
		},
		isDetailDisabled() {
			return this.form.thematic_selected == null || this.details[this.form.thematic_selected] == null; // this.form.support_selected == null
		},

		// There must be a better way to handle this translation
		support_options() {
			return [
				{value: "support_mobile", text: this.$t("Report.Support.support_mobile")},
				{value: "support_web", text: this.$t("Report.Support.support_web")},
				{value: "support_both", text: this.$t("Report.Support.support_both")},
			];
		},

		// 5 contexts over 3 supports
		contexts() {
			return {
				support_mobile: [
					{value: "context_mobile_conn", text: this.$t("Report.Context.context_mobile_conn")},
					{value: "context_mobile_editor", text: this.$t("Report.Context.context_mobile_editor")},
				],

				support_web: [
					{value: "context_web_conn", text: this.$t("Report.Context.context_web_conn")},
					{value: "context_web_editor", text: this.$t("Report.Context.context_web_editor")},
				],

				support_both: [
					{value: "context_both_conn", text: this.$t("Report.Context.context_both_conn")},
				],
			};
		},

		// 9 thematics over 5 contexts
		thematics() {
			return {
				context_mobile_conn: [
					{
						value: "thematic_mobile_conn_wronglogin",
						text: this.$t("Report.Thematic.thematic_mobile_conn_wronglogin"),
					},
				],

				context_mobile_editor: [
					{
						value: "thematic_mobile_editor_interview",
						text: this.$t("Report.Thematic.thematic_mobile_editor_interview"),
					},
					{
						value: "thematic_mobile_editor_reportage",
						text: this.$t("Report.Thematic.thematic_mobile_editor_reportage"),
					},
				],

				context_web_conn: [
					{
						value: "thematic_web_conn_wronglogin",
						text: this.$t("Report.Thematic.thematic_web_conn_wronglogin"),
					},
				],

				context_web_editor: [
					{value: "thematic_web_editor_newvid", text: this.$t("Report.Thematic.thematic_web_editor_newvid")},
					{
						value: "thematic_web_editor_interview",
						text: this.$t("Report.Thematic.thematic_web_editor_interview"),
					},
					{
						value: "thematic_web_editor_reportage",
						text: this.$t("Report.Thematic.thematic_web_editor_reportage"),
					},
				],

				context_both_conn: [
					{value: "thematic_both_conn_export", text: this.$t("Report.Thematic.thematic_both_conn_export")},
					{value: "thematic_both_conn_mail", text: this.$t("Report.Thematic.thematic_both_conn_mail")},
				],
			};
		},

		// too many (51) details over 9 options
		details() {
			return {
				thematic_both_conn_export: [
					{
						value: "detail_both_conn_export_notsending",
						text: this.$t("Report.Detail.detail_both_conn_export_notsending"),
					},
				],
				thematic_both_conn_mail: [
					{
						value: "detail_both_conn_mail_notsending",
						text: this.$t("Report.Detail.detail_both_conn_mail_notsending"),
					},
				],

				thematic_mobile_editor_interview: [
					{
						value: "detail_mobile_editor_interview_stepedit",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_stepedit"),
					},
					{
						value: "detail_mobile_editor_interview_stepvalid",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_stepvalid"),
					},
					{
						value: "detail_mobile_editor_interview_steprepview",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_steprepview"),
					},
					{
						value: "detail_mobile_editor_interview_voice",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_voice"),
					},
					{
						value: "detail_mobile_editor_interview_rush",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_rush"),
					},
					{
						value: "detail_mobile_editor_interview_duplicate",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_duplicate"),
					},
					{
						value: "detail_mobile_editor_interview_subtitles",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_subtitles"),
					},
					{
						value: "detail_mobile_editor_interview_translation",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_translation"),
					},
					{
						value: "detail_mobile_editor_interview_nofinal",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_nofinal"),
					},
					{
						value: "detail_mobile_editor_interview_wrongfinal",
						text: this.$t("Report.Detail.detail_mobile_editor_interview_wrongfinal"),
					},
				],
				thematic_mobile_editor_reportage: [
					{
						value: "detail_mobile_editor_reportage_stepedit",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_stepedit"),
					},
					{
						value: "detail_mobile_editor_reportage_stepvalid",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_stepvalid"),
					},
					{
						value: "detail_mobile_editor_reportage_steprepview",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_steprepview"),
					},
					{
						value: "detail_mobile_editor_reportage_voice",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_voice"),
					},
					{
						value: "detail_mobile_editor_reportage_infography",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_infography"),
					},
					{
						value: "detail_mobile_editor_reportage_rush",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_rush"),
					},
					{
						value: "detail_mobile_editor_reportage_duplicate",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_duplicate"),
					},
					{
						value: "detail_mobile_editor_reportage_subtitles",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_subtitles"),
					},
					{
						value: "detail_mobile_editor_reportage_translation",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_translation"),
					},
					{
						value: "detail_mobile_editor_reportage_nofinal",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_nofinal"),
					},
					{
						value: "detail_mobile_editor_reportage_wrongfinal",
						text: this.$t("Report.Detail.detail_mobile_editor_reportage_wrongfinal"),
					},
				],

				thematic_web_editor_interview: [
					{
						value: "detail_web_editor_interview_stepedit",
						text: this.$t("Report.Detail.detail_web_editor_interview_stepedit"),
					},
					{
						value: "detail_web_editor_interview_editsubtitles",
						text: this.$t("Report.Detail.detail_web_editor_interview_editsubtitles"),
					},
					{
						value: "detail_web_editor_interview_gensubtitles",
						text: this.$t("Report.Detail.detail_web_editor_interview_gensubtitles"),
					},
					{
						value: "detail_web_editor_interview_cut",
						text: this.$t("Report.Detail.detail_web_editor_interview_cut"),
					},
					{
						value: "detail_web_editor_interview_insertvideo",
						text: this.$t("Report.Detail.detail_web_editor_interview_insertvideo"),
					},
					{
						value: "detail_web_editor_interview_insertcut",
						text: this.$t("Report.Detail.detail_web_editor_interview_insertcut"),
					},
					{
						value: "detail_web_editor_interview_infography",
						text: this.$t("Report.Detail.detail_web_editor_interview_infography"),
					},
					{
						value: "detail_web_editor_interview_addstep",
						text: this.$t("Report.Detail.detail_web_editor_interview_addstep"),
					},
					{
						value: "detail_web_editor_interview_nosubtitles",
						text: this.$t("Report.Detail.detail_web_editor_interview_nosubtitles"),
					},
					{
						value: "detail_web_editor_interview_notranslation",
						text: this.$t("Report.Detail.detail_web_editor_interview_notranslation"),
					},
					{
						value: "detail_web_editor_interview_nofinal",
						text: this.$t("Report.Detail.detail_web_editor_interview_nofinal"),
					},
					{
						value: "detail_web_editor_interview_wrongfinal",
						text: this.$t("Report.Detail.detail_web_editor_interview_wrongfinal"),
					},
					{
						value: "detail_web_editor_interview_badfinal",
						text: this.$t("Report.Detail.detail_web_editor_interview_badfinal"),
					},
					{
						value: "detail_web_editor_interview_sound",
						text: this.$t("Report.Detail.detail_web_editor_interview_sound"),
					},
				],
				thematic_web_editor_reportage: [
					{
						value: "detail_web_editor_reportage_stepedit",
						text: this.$t("Report.Detail.detail_web_editor_reportage_stepedit"),
					},
					{
						value: "detail_web_editor_reportage_editsubtitles",
						text: this.$t("Report.Detail.detail_web_editor_reportage_editsubtitles"),
					},
					{
						value: "detail_web_editor_reportage_gensubtitles",
						text: this.$t("Report.Detail.detail_web_editor_reportage_gensubtitles"),
					},
					{
						value: "detail_web_editor_reportage_cut",
						text: this.$t("Report.Detail.detail_web_editor_reportage_cut"),
					},
					{
						value: "detail_web_editor_reportage_insertvideo",
						text: this.$t("Report.Detail.detail_web_editor_reportage_insertvideo"),
					},
					{
						value: "detail_web_editor_reportage_insertcut",
						text: this.$t("Report.Detail.detail_web_editor_reportage_insertcut"),
					},
					{
						value: "detail_web_editor_reportage_infography",
						text: this.$t("Report.Detail.detail_web_editor_reportage_infography"),
					},
					{
						value: "detail_web_editor_reportage_addstep",
						text: this.$t("Report.Detail.detail_web_editor_reportage_addstep"),
					},
					{
						value: "detail_web_editor_reportage_nosubtitles",
						text: this.$t("Report.Detail.detail_web_editor_reportage_nosubtitles"),
					},
					{
						value: "detail_web_editor_reportage_notranslation",
						text: this.$t("Report.Detail.detail_web_editor_reportage_notranslation"),
					},
					{
						value: "detail_web_editor_reportage_nofinal",
						text: this.$t("Report.Detail.detail_web_editor_reportage_nofinal"),
					},
					{
						value: "detail_web_editor_reportage_wrongfinal",
						text: this.$t("Report.Detail.detail_web_editor_reportage_wrongfinal"),
					},
					{
						value: "detail_web_editor_reportage_badfinal",
						text: this.$t("Report.Detail.detail_web_editor_reportage_badfinal"),
					},
					{
						value: "detail_web_editor_reportage_sound",
						text: this.$t("Report.Detail.detail_web_editor_reportage_sound"),
					},
				],
			};
		},
	},
	created() {
	},
	methods: {
		support_change(evt) {
			this.form.context_selected = null;
			this.form.thematic_selected = null;
			this.form.detail_selected = null;
		},
		context_change(evt) {
			this.form.thematic_selected = null;
			this.form.detail_selected = null;
		},
		thematic_change(evt) {
			this.form.detail_selected = null;
		},
		onTest(evt) {
			evt.preventDefault();
			alert(this.details[this.form.thematic_selected]);
			// alert(JSON.stringify(this.form))
			alert(this.disabled);
		},
		onSubmit(evt) {
			evt.preventDefault();
			let $this = this;
			axios.post(
				"https://horoquartz.enjoyb.net/py/form/report",
				this.form, {
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).catch(function (error) {
				// error
				console.log(error);
				$this.$refs["modal_error"].show();
			}).then(response => {
				let data = response.data;
				$this.$refs["modal_success"].show();
			});
		},
		redirect() {
			this.$router.push({name: "Dashboard"});
		},
	},
};
</script>

<style scoped>

h2 {
	font-size: 1.6em;
	color: #004F9E;
}

#form_report {
	min-width: 600px;
	margin: 100px auto 50px;
}

.form-control.no-border {
	border-top: 0;
	border-left: 0;
	border-right: 0;
	border-bottom: solid 1px;
}

.inactive {
	opacity: .4;
}

.nonAvailable {
	text-align: center;
	z-index: 1;
	top: 40%;
	color: darkred;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 22px;
	left: 10%;
	width: 80%;
}

.disable {
	cursor: default;
	pointer-events: none;
}

/*#flash{*/
/*animation: Flash 5s infinite;*/
/*}*/
/*@keyframes Flash{*/
/*0%{opacity: 1;}*/
/*50%{opacity: 0;}*/
/*100%{opacity: 1;}*/
/*}*/
.card {
	width: 100%;
	border-radius: 10px;
	position: relative;
	padding-left: 0;
	padding-right: 0;
}

.card-text {
	text-align: center;
	z-index: 1;
	top: 57%;
	color: #004F9E;
	position: absolute;
	font-weight: bold;
	background-color: #FFFFFF;
	font-size: 14px;
	left: 10%;
	width: 80%;
}

.card-date {
	margin-top: .5rem;
	position: absolute;
	text-align: center;
	font-size: 14px;
	font-weight: 700;
	width: 80%;
	display: table;
	left: 10%;
	color: white;
}

.card-username {
	text-align: center;
	z-index: 1;
	top: 65%;
	color: white;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 10px;
	left: 10%;
	width: 80%;
}

.card-body {
	text-align: center;
	background-color: #004F9E;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
}

.card .card-img-top {
	width: 100%;
}

.card_new_project {
	width: 200px;
	height: 320px;
	border-radius: 10px;
	margin-right: 10px;
	background-color: #004F9E;
}

.card_new_project .card-img-top {
	height: 100%;
	width: 120%;
	margin: 0;
}

.item_download a {
	width: 200px;
}

.item_download a:hover {
	text-decoration: none;
}

.item_download img {
	margin: 100px auto 0;
}

.document_description {
	text-align: center;
	margin: 10px auto;
	color: #144B5E;
}

</style>
